import { Address } from "./address.tsx";

export class Wallet {
    private amex_express_checkout: any | null | undefined;
    private apple_pay: any | null | undefined;
    private dynamic_last4: string | null | undefined;
    private google_pay: any | null | undefined;
    private link: any | null | undefined;
    private masterpass: Masterpass | null | undefined;
    private samsung_pay: any | null | undefined;
    private type: string;
    private visa_checkout: VisaCheckout | null | undefined;

    constructor(amex_express_checkout: any | null | undefined, apple_pay: any | null | undefined, dynamic_last4: string | null | undefined, google_pay: any | null | undefined, link: any | null | undefined, masterpass: Masterpass | null | undefined, samsung_pay: any | null | undefined, type: string, visa_checkout: VisaCheckout | null | undefined) {
        this.setAmexExpressCheckout(amex_express_checkout);
        this.setApplePay(apple_pay);
        this.setDynamicLast4(dynamic_last4);
        this.setGooglePay(google_pay);
        this.setLink(link);
        this.setMasterpass(masterpass);
        this.setSamsungPay(samsung_pay);
        this.setType(type);
        this.setVisaCheckout(visa_checkout);
    }

    static fromJson(json:any) {
        return new Wallet(json.amex_express_checkout, json.apple_pay, json.dynamic_last4, json.google_pay, json.link, json.masterpass !== null && json.masterpass !== undefined ? Masterpass.fromJson(json.masterpass) : null, json.samsung_pay, json.type, json.visa_checkout !== null && json.visa_checkout !== undefined ? VisaCheckout.fromJson(json.visa_checkout) : null);
    }

    setAmexExpressCheckout(newAmexExpressCheckout:any | null | undefined) {
        this.amex_express_checkout = newAmexExpressCheckout;
    }
    setApplePay(newApplePay:any | null | undefined) {
        this.apple_pay = newApplePay;
    }
    setDynamicLast4(newDynamicLast4:string | null | undefined) {
        this.dynamic_last4 = newDynamicLast4;
    }
    setGooglePay(newGooglePay:any | null | undefined) {
        this.google_pay = newGooglePay;
    }
    setLink(newLink:any | null | undefined) {
        this.link = newLink;
    }
    setMasterpass(newMasterpass:Masterpass | null | undefined) {
        this.masterpass = newMasterpass;
    }
    setSamsungPay(newSamsungPay:any | null | undefined) {
        this.samsung_pay = newSamsungPay;
    }
    setType(newType:string) {
        this.type = newType;
    }
    setVisaCheckout(newVisaCheckout:VisaCheckout | null | undefined) {
        this.visa_checkout = newVisaCheckout;
    }

    getAmexExpressCheckout() {
        return this.amex_express_checkout;
    }
    getApplePay() {
        return this.apple_pay;
    }
    getDynamicLast4() {
        return this.dynamic_last4;
    }
    getGooglePay() {
        return this.google_pay;
    }
    getLink() {
        return this.link;
    }
    getMasterpass() {
        return this.masterpass;
    }
    getSamsungPay() {
        return this.samsung_pay;
    }
    getType() {
        return this.type;
    }
    getVisaCheckout() {
        return this.visa_checkout;
    }
}

export class Masterpass {
    private billing_address: Address | null | undefined;
    private email: string | null | undefined;
    private name: string | null | undefined;
    private shipping_address: Address | null | undefined;

    constructor(billing_address: Address | null | undefined, email: string | null | undefined, name: string | null | undefined, shipping_address: Address | null | undefined) {
        this.setBillingAddress(billing_address);
        this.setEmail(email);
        this.setName(name);
        this.setShippingAddress(shipping_address);
    }

    static fromJson(json:any) {
        return new Masterpass(json.billing_address !== null && json.billing_address !== undefined ? Address.fromJson(json.billing_address) : null, json.email, json.name, json.shipping_address !== null && json.shipping_address !== undefined ? Address.fromJson(json.shipping_address) : null);
    }

    setBillingAddress(newBillingAddress:Address | null | undefined) {
        this.billing_address = newBillingAddress;
    }
    setEmail(newEmail:string | null | undefined) {
        this.email = newEmail;
    }
    setName(newName:string | null | undefined) {
        this.name = newName;
    }
    setShippingAddress(newShippingAddress:Address | null | undefined) {
        this.shipping_address = newShippingAddress;
    }

    getBillingAddress() {
        return this.billing_address;
    }
    getEmail() {
        return this.email;
    }
    getName() {
        return this.name;
    }
    getShippingAddress() {
        return this.shipping_address;
    }
}

export class VisaCheckout {
    private billing_address: Address | null | undefined;
    private email: string | null | undefined;
    private name: string | null | undefined;
    private shipping_address: Address | null | undefined;

    constructor(billing_address: Address | null | undefined, email: string | null | undefined, name: string | null | undefined, shipping_address: Address | null | undefined) {
        this.setBillingAddress(billing_address);
        this.setEmail(email);
        this.setName(name);
        this.setShippingAddress(shipping_address);
    }

    static fromJson(json:any) {
        return new VisaCheckout(json.billing_address !== null && json.billing_address !== undefined ? Address.fromJson(json.billing_address) : null, json.email, json.name, json.shipping_address !== null && json.shipping_address !== undefined ? Address.fromJson(json.shipping_address) : null);
    }

    setBillingAddress(newBillingAddress:Address | null | undefined) {
        this.billing_address = newBillingAddress;
    }
    setEmail(newEmail:string | null | undefined) {
        this.email = newEmail;
    }
    setName(newName:string | null | undefined) {
        this.name = newName;
    }
    setShippingAddress(newShippingAddress:Address | null | undefined) {
        this.shipping_address = newShippingAddress;
    }

    getBillingAddress() {
        return this.billing_address;
    }
    getEmail() {
        return this.email;
    }
    getName() {
        return this.name;
    }
    getShippingAddress() {
        return this.shipping_address;
    }
}